var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaso5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    d: "M47.6579 74.0634C61.6816 74.0634 73.05 62.6909 73.05 48.6622C73.05 34.6335 61.6816 23.261 47.6579 23.261C33.6342 23.261 22.2658 34.6335 22.2658 48.6622C22.2658 62.6909 33.6342 74.0634 47.6579 74.0634Z",
    fill: "url(#paint0_radial_1569_7308)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1706 55.5094L51.7937 40.3339C51.8544 40.2412 51.9331 40.1617 52.0252 40.1C52.1173 40.0383 52.2208 39.9958 52.3296 39.9749C52.4384 39.9539 52.5503 39.9551 52.6586 39.9782C52.767 40.0013 52.8696 40.046 52.9604 40.1095C53.0512 40.173 53.1283 40.2541 53.1871 40.348C53.246 40.4418 53.2854 40.5466 53.3031 40.656C53.3207 40.7653 53.3162 40.8772 53.2898 40.9848C53.2634 41.0924 53.2157 41.1936 53.1495 41.2824L42.0364 57.1582C41.9729 57.2493 41.8916 57.3267 41.7975 57.3858C41.7034 57.4448 41.5984 57.4843 41.4888 57.5019C41.3791 57.5196 41.267 57.5149 41.1591 57.4883C41.0513 57.4617 40.9499 57.4136 40.861 57.347L34.9014 52.8772C34.8144 52.812 34.7412 52.7303 34.6858 52.6368C34.6304 52.5432 34.594 52.4397 34.5786 52.3321C34.5476 52.1148 34.6041 51.894 34.7359 51.7184C34.8676 51.5428 35.0637 51.4267 35.281 51.3956C35.4983 51.3646 35.7191 51.4212 35.8947 51.5529L41.1706 55.5094ZM52.9459 47.6013C52.7263 47.6013 52.5158 47.5141 52.3606 47.3589C52.2053 47.2036 52.1181 46.9931 52.1181 46.7736C52.1181 46.554 52.2053 46.3435 52.3606 46.1883C52.5158 46.0331 52.7263 45.9458 52.9459 45.9458H57.9122C58.1318 45.9458 58.3423 46.0331 58.4975 46.1883C58.6527 46.3435 58.74 46.554 58.74 46.7736C58.74 46.9931 58.6527 47.2036 58.4975 47.3589C58.3423 47.5141 58.1318 47.6013 57.9122 47.6013H52.9459ZM49.635 52.5677C49.4154 52.5677 49.2049 52.4805 49.0497 52.3252C48.8944 52.17 48.8072 51.9595 48.8072 51.7399C48.8072 51.5204 48.8944 51.3099 49.0497 51.1546C49.2049 50.9994 49.4154 50.9122 49.635 50.9122H57.9106C58.1301 50.9122 58.3406 50.9994 58.4959 51.1546C58.6511 51.3099 58.7383 51.5204 58.7383 51.7399C58.7383 51.9595 58.6511 52.17 58.4959 52.3252C58.3406 52.4805 58.1301 52.5677 57.9106 52.5677H49.635ZM46.324 57.534C46.1045 57.534 45.894 57.4468 45.7388 57.2916C45.5835 57.1364 45.4963 56.9258 45.4963 56.7063C45.4963 56.4868 45.5835 56.2762 45.7388 56.121C45.894 55.9658 46.1045 55.8786 46.324 55.8786H57.9106C58.1301 55.8786 58.3406 55.9658 58.4959 56.121C58.6511 56.2762 58.7383 56.4868 58.7383 56.7063C58.7383 56.9258 58.6511 57.1364 58.4959 57.2916C58.3406 57.4468 58.1301 57.534 57.9106 57.534H46.324Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1569_7308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2622 52.4273) scale(30.758 29.5382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D3DBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B9C6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9AACBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#758EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4B6B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345978"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaso5);
export default __webpack_public_path__ + "static/media/paso_5.9aee3ce6933ae79b4531614ee33c4891.svg";
export { ForwardRef as ReactComponent };